import { createReducer, on } from "@ngrx/store";
import { Position } from "../../models/position";
import { loadPositionByIdAct, saveSuccessPositionAct, setViolationsPositionAct, updateSuccessPositionAct } from "./position.actions";

const position: Position = new Position();

export const positionReducer = createReducer(
    {
        position,
        violations: {},
        loading: true
    },
    /*CRUD CATALOG POSITIONS*/
    /*on(loadAllPositionsCatalogAct, (state, { positions }) => ({
        position: state.position,
        violations: state.violations,
        loading: false,
    })),*/
    on(loadPositionByIdAct, (state, { position }) => ({
        position: position,
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessPositionAct, (state, { positionNew }) => ({
        position: { ...positionNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessPositionAct, (state, { positionUpdated }) => ({
        position: { ...positionUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsPositionAct, (state, { positionForm, violations }) => ({
        position: { ...positionForm },
        violations: {...violations},
        loading: state.loading
    })),
    /*CRUD CATALOG POSITIONS END*/
)